
import { AmmunitionStockEventMetadataBase } from './ammunition-stock-event.metadata.base';


export class AmmunitionStockEventMetadata extends AmmunitionStockEventMetadataBase {
  constructor() {
    super();
  }
}

export const AMMUNITION_STOCK_EVENT_METADATA: AmmunitionStockEventMetadata = new AmmunitionStockEventMetadata();


